export default {
  lang_name: '\uD55C\uAD6D\uC5B4',
  tab_main: '\uBA54\uC778', tab_upgrade: '\uC5C5\uADF8\uB808\uC774\uB4DC', tab_prestige: '\uD658\uC0DD', tab_achievement: '\uC5C5\uC801', tab_mission: '\uBBF8\uC158', tab_domination: '\uC815\uBCF5', tab_settings: '\uC124\uC815',
  hud_cps: '/\uCD08', hud_boost: '\uBD80\uC2A4\uD2B8',
  main_tap_area: '\uD0ED!', main_combo: '\uCF64\uBCF4',

  prod_informant: '\uC815\uBCF4\uC6D0', prod_informant_desc: '\uAC70\uB9AC\uC5D0\uC11C \uC815\uBCF4 \uC218\uC9D1',
  prod_hacker: '\uD574\uCEE4', prod_hacker_desc: '\uC778\uAC04 \uB124\uD2B8\uC6CC\uD06C \uCE68\uC785',
  prod_disguiser: '\uBCC0\uC7A5 \uC804\uBB38\uAC00', prod_disguiser_desc: '\uC778\uAC04\uC73C\uB85C \uBCC0\uC7A5\uD558\uC5EC \uCE68\uD22C',
  prod_mindController: '\uC2EC\uB9AC \uC870\uC885\uC0AC', prod_mindController_desc: '\uC778\uAC04 \uC5EC\uB860 \uC870\uC791',
  prod_secretLab: '\uBE44\uBC00 \uC5F0\uAD6C\uC18C', prod_secretLab_desc: '\uB80C\uD2F8\uB9AC\uC5B8 \uAE30\uC220 \uC5F0\uAD6C',
  prod_mediaCell: '\uBBF8\uB514\uC5B4 \uC870\uC791\uBC18', prod_mediaCell_desc: '\uB274\uC2A4/SNS \uC7A5\uC545',
  prod_shadowGovt: '\uADF8\uB9BC\uC790 \uC815\uBD80', prod_shadowGovt_desc: '\uC815\uCE58\uC778 \uAD50\uCCB4 \uC791\uC804',
  prod_deepBase: '\uC2EC\uCE35 \uAE30\uC9C0', prod_deepBase_desc: '\uC9C0\uD558 \uAC70\uB300 \uAE30\uC9C0 \uC6B4\uC601',
  prod_orbitalStation: '\uADA4\uB3C4 \uC704\uC131', prod_orbitalStation_desc: '\uC778\uACF5\uC704\uC131 \uAC10\uC2DC\uB9DD',
  prod_dimensionGate: '\uCC28\uC6D0 \uAC8C\uC774\uD2B8', prod_dimensionGate_desc: '\uBCF8\uC131\uC5D0\uC11C \uBCD1\uB825 \uC18C\uD658',
  prod_planetController: '\uD589\uC131 \uC81C\uC5B4\uAE30', prod_planetController_desc: '\uC9C0\uAD6C \uC2DC\uC2A4\uD15C \uC9C1\uC811 \uC870\uC791',
  prod_galacticBeacon: '\uC740\uD558 \uC2E0\uD638\uAE30', prod_galacticBeacon_desc: '\uC740\uD558 \uBCF8\uBD80\uC640 \uC9C1\uD1B5',
  prod_locked: '\uD574\uAE08: ', prod_locked_prestige: '\uD658\uC0DD {n}\uD68C', prod_locked_time: '{n}\uBD84 \uD50C\uB808\uC774',

  milestone_squad: '\uC18C\uADDC\uBAA8 \uBD84\uB300 \uD3B8\uC131', milestone_company: '\uC911\uB300 \uD3B8\uC131 \uC644\uB8CC',
  milestone_battalion: '\uB300\uB300\uAE09 \uC804\uB825', milestone_regiment: '\uC5F0\uB300\uAE09 \uC804\uB825',
  milestone_division: '\uC0AC\uB2E8\uAE09 \uC804\uB825', milestone_corps: '\uAD70\uB2E8\uAE09 \uC804\uB825',

  click_basic_training: '\uAE30\uBCF8 \uD6C8\uB828', click_combat_training: '\uC804\uD22C \uD6C8\uB828',
  click_psychic_awaken: '\uC0AC\uC774\uD0A5 \uAC01\uC131', click_transform: '\uBCC0\uC2E0 \uAC15\uD654',
  click_telepathy: '\uD154\uB808\uD30C\uC2DC', click_critical_eye: '치명적 안목',
  click_dimension_sense: '\uCC28\uC6D0 \uAC10\uAC01', click_galaxy_field: '\uC740\uD558 \uC5ED\uC7A5',
  click_lethal_strike: '필살 일격', click_absolute: '\uC808\uB300 \uCE68\uD22C\uB825',
  click_planet_destroyer: '\uD589\uC131 \uD30C\uAD34\uC790', click_galaxy_finger: '\uC740\uD558 \uC9C0\uBC30\uC790\uC758 \uC190\uAC00\uB77D',

  special_info_network: '\uC815\uBCF4 \uB124\uD2B8\uC6CC\uD06C', special_info_network_desc: '\uC815\uBCF4\uC6D0 & \uD574\uCEE4 \uC218\uC775 x2',
  special_perfect_disguise: '\uC644\uBCBD\uD55C \uC704\uC7A5', special_perfect_disguise_desc: '\uBAA8\uB4E0 \uC694\uC6D0 \uC218\uC775 x1.5',
  special_mass_brainwash: '\uB300\uC911 \uC138\uB1CC', special_mass_brainwash_desc: '\uC2EC\uB9AC\uC870\uC885\uC0AC & \uBBF8\uB514\uC5B4 \uC218\uC775 x3',
  special_shadow_network: '\uADF8\uB9BC\uC790 \uB124\uD2B8\uC6CC\uD06C', special_shadow_network_desc: '\uC624\uD504\uB77C\uC778 \uC218\uC775 +25%',
  special_underground_empire: '\uC9C0\uD558 \uC81C\uAD6D', special_underground_empire_desc: '\uBAA8\uB4E0 \uC694\uC6D0 \uC218\uC775 x2',
  special_orbital_surveillance: '\uADA4\uB3C4 \uAC10\uC2DC\uB9DD', special_orbital_surveillance_desc: '\uACE8\uB4E0 \uC774\uBCA4\uD2B8 \uBE48\uB3C4 +50%',
  special_dimension_supply: '\uCC28\uC6D0 \uBCD1\uCC38\uC120', special_dimension_supply_desc: '\uD0ED \uC218\uC775 x5',
  special_galactic_alliance: '\uC740\uD558 \uB3D9\uB9F9', special_galactic_alliance_desc: '\uCD08\uB2F9 \uD83D\uDEF8 \uC218\uC775 x10',
  special_combo_master: '\uCF64\uBCF4 \uB9C8\uC2A4\uD130', special_combo_master_desc: '\uCF64\uBCF4 \uBC30\uC728 \uC0C1\uD55C 3\uBC30',
  special_time_warp: '\uC2DC\uAC04 \uC654\uACE1', special_time_warp_desc: '\uC624\uD504\uB77C\uC778 \uCE61 12\uC2DC\uAC04',
  special_agent_synergy: '\uC694\uC6D0 \uC2DC\uB108\uC9C0', special_agent_synergy_desc: '\uCD08\uB2F9 \uD83D\uDEF8 \uC218\uC775 x1.5',
  special_massive_infiltration: '\uB300\uADDC\uBAA8 \uCE68\uD22C', special_massive_infiltration_desc: '\uCD08\uB2F9 \uD83D\uDEF8 \uC218\uC775 x2',

  subtab_click: '\uD074\uB9AD', subtab_special: '\uD2B9\uC218',

  prestige_title: '\uC870\uC9C1 \uC7AC\uD3B8', prestige_total_ip: '\uCD1D \uB204\uC801 \uD83D\uDEF8',
  prestige_gc_gain: '\uD68D\uB4DD \uC608\uC815 \uD83D\uDC8E', prestige_gc_current: '\uD604\uC7AC \uD83D\uDC8E',
  prestige_execute: '\uC870\uC9C1 \uC7AC\uD3B8', prestige_confirm: '\uBAA8\uB4E0 \uC9C4\uD589\uC744 \uB9AC\uC14B\uD558\uACE0 {gc} \uD83D\uDC8E\uC744 \uD68D\uB4DD\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',
  prestige_ad_bonus: '\uAD11\uACE0 \uBCF4\uACE0 \uD83D\uDC8E +50%',
  prestige_requirement: '\uD658\uC0DD\uC5D0\uB294 100\uC5B5 \uD83D\uDEF8 \uC774\uC0C1 \uD544\uC694',
  prestige2_title: '\uC740\uD558 \uC7AC\uD3B8', prestige2_cores_gain: '\uD68D\uB4DD \uC608\uC815 \uD83D\uDD2E',
  prestige2_cores_current: '\uD604\uC7AC \uD83D\uDD2E', prestige2_execute: '\uC740\uD558 \uC7AC\uD3B8',
  prestige2_requirement: '\uD658\uC0DD 15\uD68C \uC774\uC0C1 & \uCD1D \uD83D\uDC8E 100 \uC774\uC0C1 \uD544\uC694',
  prestige2_confirm: '\uBAA8\uB4E0 \uAC83\uC744 \uCD08\uAE30\uD654\uD558\uACE0 {cores} \uD83D\uDD2E\uB97C \uD68D\uB4DD\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',

  pup_galaxy_mult: '\uC740\uD558 \uBC30\uC728', pup_galaxy_mult_desc: '\uB808\uBCA8\uB2F9 \uCD08\uB2F9 \uC218\uC775 x1.5 (\uB808\uBCA8\uC774 \uC624\uB97C\uC218\uB85D \uBC30\uB85C \uC911\uCCA9)',
  pup_infil_accel: '\uCE68\uD22C \uAC00\uC18D', pup_infil_accel_desc: '\uD658\uC0DD \uC2DC \uB808\uBCA8\uB2F9 1\uC5B5 \uD83D\uDEF8\uB97C \uAC00\uC9C0\uACE0 \uC2DC\uC791',
  pup_tap_enhance: '\uD0ED \uAC15\uD654', pup_tap_enhance_desc: '\uB808\uBCA8\uB2F9 \uD0ED \uC218\uC775 x2 (\uBC30\uB85C \uC911\uCCA9)',
  pup_offline_expand: '\uC624\uD504\uB77C\uC778 \uD655\uC7A5', pup_offline_expand_desc: '\uC811\uC18D \uC548 \uD560 \uB54C \uBCF4\uC0C1 \uCD5C\uB300 \uC2DC\uAC04 +1h/Lv (\uAE30\uBCF8 8h)',
  pup_offline_eff: '\uC624\uD504\uB77C\uC778 \uD6A8\uC728', pup_offline_eff_desc: '\uC624\uD504\uB77C\uC778 \uC218\uC775\uB960 +10%p/Lv (\uAE30\uBCF8 50%)',
  pup_agent_discount: '\uC694\uC6D0 \uD560\uC778', pup_agent_discount_desc: '\uB808\uBCA8\uB2F9 \uC694\uC6D0 \uACE0\uC6A9 \uBE44\uC6A9 -10% (\uCD5C\uB300 -50%)',
  pup_auto_click: '\uC790\uB3D9 \uD074\uB9AD', pup_auto_click_desc: '\uB808\uBCA8\uB2F9 \uCD08\uB2F9 3\uD68C \uC790\uB3D9 \uD0ED (\uCD5C\uB300 15\uD68C/\uCD08)',
  pup_golden_luck: '\uD669\uAE08 \uC6B4', pup_golden_luck_desc: '\uACE8\uB4E0 \uC774\uBCA4\uD2B8 \uBCF4\uC0C1 +20%/Lv (\uCD5C\uB300 +200%)',
  pup_combo_keep: '\uCF64\uBCF4 \uC720\uC9C0', pup_combo_keep_desc: '\uCF64\uBCF4 \uC720\uD6A8\uC2DC\uAC04 +0.5\uCD08/Lv (\uAE30\uBCF8 2\uCD08)',
  pup_quick_start: '\uBE60\uB978 \uC2DC\uC791', pup_quick_start_desc: '\uD658\uC0DD \uD6C4 \uCCAB 5\uAC1C \uC694\uC6D0\uC744 1\uBA85\uC529 \uC790\uB3D9 \uC9C0\uAE09',

  p2up_galaxy_speed: '\uC740\uD558 \uBC30\uC18D', p2up_galaxy_speed_desc: '\uB808\uBCA8\uB2F9 \uD658\uC0DD \uC2DC \uD83D\uDC8E \uD68D\uB4DD\uB7C9 x2 (\uBC30\uB85C \uC911\uCCA9)',
  p2up_auto_prestige: '\uC790\uB3D9 \uD658\uC0DD', p2up_auto_prestige_desc: '100\uC5B5 \uD83D\uDEF8 \uB3C4\uB2EC \uC2DC \uC790\uB3D9\uC73C\uB85C \uD658\uC0DD \uC2E4\uD589',
  p2up_permanent: '\uC601\uAD6C \uC694\uC6D0', p2up_permanent_desc: '\uD658\uC0DD \uD6C4\uC5D0\uB3C4 \uCD08\uAE30 \uC694\uC6D0 3\uC885\uC744 \uBCF4\uC874',
  p2up_dimension_accel: '\uCC28\uC6D0 \uAC00\uC18D', p2up_dimension_accel_desc: '\uB808\uBCA8\uB2F9 \uCD08\uB2F9 \uC218\uC775 x5 (\uBC30\uB85C \uC911\uCCA9, \uC601\uAD6C)',
  p2up_galaxy_memory: '\uC740\uD558 \uBA54\uBAA8\uB9AC', p2up_galaxy_memory_desc: '\uD658\uC0DD \uC2DC \uD65C\uC131\uD654\uB41C \uBD80\uC2A4\uD2B8 3\uAC1C\uB97C \uC720\uC9C0',
  p2up_spacetime: '\uC2DC\uACF5\uAC04 \uC654\uACE1', p2up_spacetime_desc: '\uC624\uD504\uB77C\uC778 \uC218\uC775\uB960\uC744 100%\uB85C \uC0C1\uD5A5 (\uC601\uAD6C)',
  p2up_automate: '\uC740\uD558 \uC790\uB3D9\uD654', p2up_automate_desc: '\uC694\uC6D0\uC744 \uC790\uB3D9\uC73C\uB85C \uACE0\uC6A9 (\uC601\uAD6C)',

  rank_e: '\uC778\uD134 \uC694\uC6D0', rank_d: '\uD558\uAE09 \uC694\uC6D0', rank_c: '\uC911\uAE09 \uC694\uC6D0', rank_b: '\uC0C1\uAE09 \uC694\uC6D0',
  rank_a: '\uAC04\uBD80', rank_s: '\uC9C0\uBD80\uC7A5', rank_ss: '\uCD1D\uC218', rank_sss: '\uC740\uD558 \uB300\uAD70\uC8FC',

  ach_title: '\uC5C5\uC801', ach_filter_all: '\uC804\uCCB4', ach_filter_tap: '\uD0ED', ach_filter_resource: '\uC790\uC6D0',
  ach_filter_producer: '\uC0DD\uC0B0\uAE30', ach_filter_prestige: '\uD658\uC0DD', ach_filter_time: '\uC2DC\uAC04',
  ach_filter_special: '\uD2B9\uC218', ach_filter_ad: '\uBB38\uC11C', ach_filter_combo: '\uCF64\uBCF4',

  ach_t01: '\uCCAB \uBC1C\uAC78\uC74C', ach_t01_reward: '\uD0ED \uD30C\uC6CC +1',
  ach_t02: '\uC190\uAC00\uB77D \uC6CC\uBC0D\uC5C5', ach_t02_reward: '\uD0ED \uD30C\uC6CC +5%',
  ach_t03: '\uAFB8\uC900\uD55C \uC694\uC6D0', ach_t03_reward: '\uD0ED \uD30C\uC6CC +10%',
  ach_t04: '\uD130\uCE58 \uB9C8\uC2A4\uD130', ach_t04_reward: '\uD0ED \uD30C\uC6CC +15%',
  ach_t05: '\uD30C\uCDA9\uB958\uC758 \uC9D1\uB150', ach_t05_reward: '\uD0ED \uD30C\uC6CC +20%',
  ach_t06: '\uC740\uD558\uAE09 \uC190\uAC00\uB77D', ach_t06_reward: '\uD0ED \uD30C\uC6CC +25%',
  ach_t07: '\uCF64\uBCF4 \uACAC\uC2B5\uC0DD', ach_t07_reward: '\uCF64\uBCF4 \uC720\uC9C0 +0.5\uCD08',
  ach_t08: '\uCF64\uBCF4 \uB9C8\uC2A4\uD130', ach_t08_reward: '\uCF64\uBCF4 \uBC30\uC728 \uC0C1\uD55C +0.5',

  ach_r01: '\uC18C\uC18C\uD55C \uC815\uBCF4', ach_r01_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +5%',
  ach_r02: '\uC815\uBCF4 \uC218\uC9D1\uAC00', ach_r02_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +5%',
  ach_r03: '\uAE30\uBC00 \uBCF4\uAD00\uD568', ach_r03_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +5%',
  ach_r04: '\uBC31\uB9CC \uCE68\uD22C', ach_r04_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +10%',
  ach_r05: '\uC5B5 \uB2E8\uC704 \uC694\uC6D0', ach_r05_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +10%',
  ach_r06: '\uC870 \uB2E8\uC704 \uC791\uC804', ach_r06_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +15%',
  ach_r07: '\uACBD \uB2E8\uC704 \uC81C\uAD6D', ach_r07_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +15%',
  ach_r08: '\uD574 \uB2E8\uC704 \uC740\uD558', ach_r08_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +20%',
  ach_r09: '\uC790 \uB2E8\uC704 \uC6B0\uC8FC', ach_r09_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +20%',
  ach_r10: '\uBB34\uD55C \uCE68\uD22C', ach_r10_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +30%',

  ach_g01: '\uCCAB \uBD80\uD558', ach_g01_reward: '\uC815\uBCF4\uC6D0 x1.5',
  ach_g02: '\uC815\uBCF4\uB9DD \uAD6C\uCD95', ach_g02_reward: '\uC815\uBCF4\uC6D0 x2',
  ach_g03: '\uD574\uD0B9 \uC2DC\uC791', ach_g03_reward: '\uD574\uCEE4 x2',
  ach_g04: '\uC0AC\uC774\uBC84 \uAD70\uB2E8', ach_g04_reward: '\uD574\uCEE4 x3',
  ach_g05: '\uC704\uC7A5\uC758 \uB2EC\uC778', ach_g05_reward: '\uBCC0\uC7A5 \uC804\uBB38\uAC00 x2',
  ach_g06: '\uC138\uB1CC \uB124\uD2B8\uC6CC\uD06C', ach_g06_reward: '\uC2EC\uB9AC \uC870\uC885\uC0AC x2',
  ach_g07: '\uB9E4\uB4DC \uC0AC\uC774\uC5B8\uC2A4', ach_g07_reward: '\uBE44\uBC00 \uC5F0\uAD6C\uC18C x2',
  ach_g08: '\uBBF8\uB514\uC5B4 \uC7A5\uC545', ach_g08_reward: '\uBBF8\uB514\uC5B4 \uC870\uC791\uBC18 x2',
  ach_g09: '\uADF8\uB9BC\uC790 \uB0B4\uAC01', ach_g09_reward: '\uADF8\uB9BC\uC790 \uC815\uBD80 x2',
  ach_g10: '\uC9C0\uD558 \uC81C\uAD6D', ach_g10_reward: '\uC2EC\uCE35 \uAE30\uC9C0 x2',
  ach_g11: '\uADA4\uB3C4 \uC9C0\uBC30', ach_g11_reward: '\uADA4\uB3C4 \uC704\uC131 x2',
  ach_g12: '\uC740\uD558\uC758 \uC8FC\uC778', ach_g12_reward: '\uC804\uCCB4 \uCD08\uB2F9 \uD83D\uDEF8 x2',

  ach_p01: '\uCCAB \uBC88\uC9F8 \uC7AC\uD3B8', ach_p01_reward: '\uD83D\uDC8E +5 \uBCF4\uB108\uC2A4',
  ach_p02: '\uC21C\uD658\uC758 \uB9DB', ach_p02_reward: '\uD83D\uDC8E \uD68D\uB4DD +10%',
  ach_p03: '\uBCA0\uD14C\uB791 \uC694\uC6D0', ach_p03_reward: '\uD83D\uDC8E \uD68D\uB4DD +10%',
  ach_p04: '\uD658\uC0DD \uC911\uB3C5', ach_p04_reward: '\uD83D\uDC8E \uD68D\uB4DD +15%',
  ach_p05: '\uBB34\uD55C \uB8E8\uD504', ach_p05_reward: '\uD83D\uDC8E \uD68D\uB4DD +20%',
  ach_p06: '\uC740\uD558\uC758 \uAE30\uC5B5', ach_p06_reward: '\uD83D\uDC8E \uD68D\uB4DD +25%',
  ach_p07: '\uC740\uD558 \uC7AC\uD3B8', ach_p07_reward: '\uD83D\uDD2E +3 \uBCF4\uB108\uC2A4',
  ach_p08: '\uCC28\uC6D0\uC758 \uC9C0\uBC30\uC790', ach_p08_reward: '\uD83D\uDD2E \uD68D\uB4DD +20%',

  ach_h01: '\uC2E0\uC785 \uCD9C\uADFC', ach_h01_reward: '\uD658\uC601 \uBCF4\uB108\uC2A4 \uD83D\uDEF8 100',
  ach_h02: '1\uC2DC\uAC04 \uADFC\uBB34', ach_h02_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +5%',
  ach_h03: '\uBC18\uB098\uC808', ach_h03_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +10%',
  ach_h04: '24\uC2DC\uAC04 \uC7A0\uBCF5', ach_h04_reward: '\uC624\uD504\uB77C\uC778 \uCE61 +2\uC2DC\uAC04',
  ach_h05: '3\uC77C \uC791\uC804', ach_h05_reward: '\uCD08\uB2F9 \uD83D\uDEF8 x1.5',
  ach_h06: '\uC77C\uC8FC\uC77C \uCE68\uD22C', ach_h06_reward: '\uCD08\uB2F9 \uD83D\uDEF8 x2',

  ach_s01: '\uC758\uC2EC \uB9CE\uC740 \uC778\uAC04', ach_s01_reward: '\uAE30\uBC00 \uBB38\uC11C 1',
  ach_s02: '\uAE68\uB057\uD55C \uCD9C\uBC1C', ach_s02_reward: '\uCE6D\uD638: \uBB34\uBAA8\uD55C \uC694\uC6D0',
  ach_s03: '\uC62C\uC778', ach_s03_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +10%',
  ach_s04: '\uC2A4\uD53C\uB4DC\uB7F0', ach_s04_reward: '\uD83D\uDC8E +10 \uBCF4\uB108\uC2A4',
  ach_s05: '\uACE8\uB4E0 \uD5CC\uD130', ach_s05_reward: '\uC774\uBCA4\uD2B8 \uC8FC\uAE30 -20%',
  ach_s06: '\uBC24\uC758 \uC694\uC6D0', ach_s06_reward: '야간 초당 🛸 x1.5',
  ach_s07: '\uBB34\uACFC\uAE08 \uC804\uC0AC', ach_s07_reward: '\uAD11\uACE0 \uBCF4\uC0C1 +30%',
  ach_s08: '\uC218\uC9D1\uAD11', ach_s08_reward: '\uCD08\uB2F9 \uD83D\uDEF8 x3',

  ach_a01: '\uAD11\uACE0 \uC785\uBB38', ach_a01_reward: '\uAE30\uBC00 \uBB38\uC11C 1',
  ach_a02: '\uAD11\uACE0 \uC560\uD638\uAC00', ach_a02_reward: '\uAE30\uBC00 \uBB38\uC11C 2',
  ach_a03: '\uAD11\uACE0 \uB9C8\uC2A4\uD130', ach_a03_reward: '\uAD11\uACE0 \uBCF4\uC0C1 +30%',
  ach_a04: '\uBB38\uC11C \uC218\uC9D1\uAC00', ach_a04_reward: '\uBB38\uC11C \uD6A8\uACFC +20%',
  ach_a05: '\uAE30\uBC00 \uC804\uBB38\uAC00', ach_a05_reward: '\uBB38\uC11C \uD6A8\uACFC +50%',

  ach_c01: '\uC5F0\uD0C0\uC758 \uC2DC\uC791', ach_c01_reward: '\uCF64\uBCF4 \uC720\uC9C0 +0.3\uCD08',
  ach_c02: '\uB9AC\uB4EC \uD0C0\uAE30', ach_c02_reward: '\uCF64\uBCF4 \uBC30\uC728 +0.1',
  ach_c03: '\uACE8\uB4E0 \uCD08\uBCF4', ach_c03_reward: '\uC774\uBCA4\uD2B8 \uBCF4\uC0C1 +10%',
  ach_c04: '\uACE8\uB4E0 \uC218\uC9D1\uAC00', ach_c04_reward: '\uC774\uBCA4\uD2B8 \uC8FC\uAE30 -10%',
  ach_c05: '\uC77C\uC77C \uBBF8\uC158 \uB9C8\uB2C8\uC544', ach_c05_reward: '\uBBF8\uC158 \uBCF4\uC0C1 +50%',

  golden_intel_leak: '\uAE30\uBC00 \uC815\uBCF4 \uC720\uCD9C!', golden_agent_frenzy: '\uC694\uC6D0 \uAD11\uB780!',
  golden_money_launder: '\uC790\uAE08 \uC138\uD0C1!', golden_facility_boost: '\uC2DC\uC124 \uAC00\uB3D9\uB960 UP!',
  golden_supply_drop: '\uC740\uD558 \uBCF4\uAE09\uD488!', golden_touch: '\uD0ED!', golden_ad_double: '\uAD11\uACE0 \uBCF4\uACE0 2\uBC30',

  offline_title: '\uBD80\uC7AC \uC911 \uC791\uC804 \uBCF4\uACE0\uC11C', offline_elapsed: '\uACBD\uACFC \uC2DC\uAC04',
  offline_earned: '\uD68D\uB4DD \uD83D\uDEF8', offline_cap: '\uCD5C\uB300 {h}\uC2DC\uAC04 \uC801\uC6A9',
  offline_claim: '\uBC1B\uAE30', offline_double: '\uAD11\uACE0 \uBCF4\uACE0 2\uBC30 \uBC1B\uAE30 ({amount})',
  offline_hours: '{h}\uC2DC\uAC04 {m}\uBD84',

  settings_title: '\uC124\uC815', settings_bgm: 'BGM', settings_sfx: '\uD6A8\uACFC\uC74C', settings_lang: '\uC5B8\uC5B4',
  settings_reset: '\uAC8C\uC784 \uCD08\uAE30\uD654', settings_reset_confirm: '\uBAA8\uB4E0 \uC9C4\uD589 \uC0C1\uD669\uC744 \uC0AD\uC81C\uD558\uACE0 \uCC98\uC74C\uBD80\uD130 \uC2DC\uC791\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',
  settings_stats: '\uD1B5\uACC4', settings_total_ip: '\uCD1D \uD68D\uB4DD \uD83D\uDEF8', settings_total_taps: '\uCD1D \uD0ED \uD69F\uC218',
  settings_total_prestiges: '\uCD1D \uD658\uC0DD \uD69F\uC218', settings_play_time: '\uCD1D \uD50C\uB808\uC774 \uC2DC\uAC04',
  settings_docs_shop: '\uAE30\uBC00 \uBB38\uC11C \uC0C1\uC810',

  doc_shop_title: '\uAE30\uBC00 \uBB38\uC11C \uC0C1\uC810',
  doc_ip_boost: '자동 수익 가속', doc_ip_boost_desc: '30초간 초당 🛸 생산량 2배',
  doc_mega_tap: '강화 탭 훈련', doc_mega_tap_desc: '30초간 탭 수익 3배',
  doc_auto_click: '자동 침투 장치', doc_auto_click_desc: '30초간 초당 10회 자동 탭',
  doc_instant_golden: '긴급 골든 소환', doc_instant_golden_desc: '골든 이벤트 즉시 발동',
  doc_timeskip: '시간 가속기', doc_timeskip_desc: '2시간치 🛸 수익 즉시 획득',
  doc_prestige_boost: '은하 증폭기', doc_prestige_boost_desc: '다음 환생 시 💎 획득량 2배',
  doc_prestige_boost_active: '다음 환생 시 💎 x2 적용 대기 중', doc_prestige_boost_active_badge: '✅ 적용 대기 중',

  ad_offline_double: '\uC624\uD504\uB77C\uC778 \uBCF4\uC0C1 2\uBC30', ad_cps_boost: '\uCD08\uB2F9 \uC218\uC775 x10 (15\uCD08)',
  ad_prestige_bonus: '\uD658\uC0DD \uD83D\uDC8E +50%', ad_timeskip: '\uD0C0\uC784\uC2A4\uD0B5 (2\uC2DC\uAC04)',
  ad_free_docs: '\uBB34\uB8CC \uAE30\uBC00 \uBB38\uC11C', ad_golden_double: '\uACE8\uB4E0 \uBCF4\uC0C1 2\uBC30',
  ad_start_boost: '\uC2A4\uD0C0\uD2B8 \uBD80\uC2A4\uD2B8 \uD329', ad_watching: '\uAD11\uACE0 \uB85C\uB529 \uC911...',
  ad_cooldown: '{t} \uD6C4 \uC0AC\uC6A9 \uAC00\uB2A5',
  settings_sfx_test: '\uD6A8\uACFC\uC74C \uD14C\uC2A4\uD2B8',
  settings_sound_reset: '\uCD08\uAE30\uD654',
  settings_sound_reset_done: '\uC0AC\uC6B4\uB4DC\uAC00 \uCD08\uAE30\uD654\uB418\uC5C8\uC2B5\uB2C8\uB2E4',

  num_k: '\uB9CC', num_m: '\uC5B5', num_b: '\uC870', num_t: '\uACBD', num_qa: '\uD574',
  num_qi: '\uC790', num_sx: '\uC591', num_sp: '\uAD6C', num_oc: '\uAC04', num_no: '\uC815', num_dc: '\uC7AC',

  // Daily Missions
  mission_title: '\uC77C\uC77C \uBBF8\uC158',
  mission_claim: '\uBC1B\uAE30',
  mission_all_complete: '\uC804\uCCB4 \uC644\uB8CC \uBCF4\uB108\uC2A4!',
  mission_clear_label: '\uBBF8\uC158',
  mission_all_clear_label: '\uC62C\uD074\uB9AC\uC5B4',
  ach_unlock_label: '\uC5C5\uC801',
  mission_diff_easy: '\uC27D\uAC8C',
  mission_diff_normal: '\uBCF4\uD1B5',
  mission_diff_hard: '\uC5B4\uB835\uAC8C',
  mission_tap_100: '\uAC00\uBCBC\uC6B4 \uD130\uCE58',
  mission_tap_100_desc: '100\uD68C \uD0ED\uD558\uAE30',
  mission_tap_300: '\uC190 \uD480\uAE30',
  mission_tap_300_desc: '300\uD68C \uD0ED\uD558\uAE30',
  mission_buy_5: '\uC18C\uADDC\uBAA8 \uBAA8\uC9D1',
  mission_buy_5_desc: '\uC0DD\uC0B0\uAE30 5\uAC1C \uAD6C\uB9E4',
  mission_combo_10: '\uCF64\uBCF4 \uC2DC\uC791',
  mission_combo_10_desc: '10 \uCF64\uBCF4 \uB2EC\uC131',
  mission_golden_1: '\uD669\uAE08 \uCEA0\uCE58',
  mission_golden_1_desc: '\uACE8\uB4E0 \uC774\uBCA4\uD2B8 1\uD68C \uD130\uCE58',
  mission_tap_1000: '\uAC15\uB825\uD55C \uD0ED',
  mission_tap_1000_desc: '1,000\uD68C \uD0ED\uD558\uAE30',
  mission_buy_20: '\uBD80\uB300 \uAD6C\uCD95',
  mission_buy_20_desc: '\uC0DD\uC0B0\uAE30 20\uAC1C \uAD6C\uB9E4',
  mission_combo_50: '\uCF64\uBCF4 \uD504\uB85C',
  mission_combo_50_desc: '50 \uCF64\uBCF4 \uB2EC\uC131',
  mission_golden_3: '\uACE8\uB4DC \uB7EC\uC2DC',
  mission_golden_3_desc: '\uACE8\uB4E0 \uC774\uBCA4\uD2B8 3\uD68C \uD130\uCE58',
  mission_earn_1m: '\uBC31\uB9CC \uC791\uC804',
  mission_earn_1m_desc: '\uD83D\uDEF8 100\uB9CC \uD68D\uB4DD',
  mission_tap_5000: '\uD0ED \uBA38\uC2E0',
  mission_tap_5000_desc: '5,000\uD68C \uD0ED\uD558\uAE30',
  mission_buy_50: '\uAD70\uB2E8 \uAD6C\uCD95',
  mission_buy_50_desc: '\uC0DD\uC0B0\uAE30 50\uAC1C \uAD6C\uB9E4',
  mission_combo_100: '\uCF64\uBCF4 \uC2E0',
  mission_combo_100_desc: '100 \uCF64\uBCF4 \uB2EC\uC131',
  mission_golden_5: '\uACE8\uB4E0 \uB9C8\uC2A4\uD130',
  mission_golden_5_desc: '\uACE8\uB4E0 \uC774\uBCA4\uD2B8 5\uD68C \uD130\uCE58',
  mission_earn_1b: '\uC5B5 \uB2E8\uC704 \uC694\uC6D0',
  mission_earn_1b_desc: '\uD83D\uDEF8 10\uC5B5 \uD68D\uB4DD',
  mission_tap_200: '빠른 손가락',
  mission_tap_200_desc: '200번 탭하기',
  mission_buy_3: '첫 모집',
  mission_buy_3_desc: '생산자 3명 구매',
  mission_combo_15: '콤보 입문',
  mission_combo_15_desc: '15 콤보 달성',
  mission_earn_10k: '용돈벌이',
  mission_earn_10k_desc: '🛸 10K 획득',
  mission_earn_100k: '자금 모금',
  mission_earn_100k_desc: '🛸 100K 획득',
  mission_tap_500: '꾸준한 탭',
  mission_tap_500_desc: '500번 탭하기',
  mission_tap_700: '끈질긴 손',
  mission_tap_700_desc: '700번 탭하기',
  mission_buy_10: '팀장',
  mission_buy_10_desc: '생산자 10명 구매',
  mission_combo_30: '콤보 체인',
  mission_combo_30_desc: '30 콤보 달성',
  mission_golden_2: '더블 골드',
  mission_golden_2_desc: '골든 이벤트 2번 터치',
  mission_tap_3000: '탭 전사',
  mission_tap_3000_desc: '3,000번 탭하기',
  mission_buy_30: '대대',
  mission_buy_30_desc: '생산자 30명 구매',
  mission_combo_75: '콤보 엘리트',
  mission_combo_75_desc: '75 콤보 달성',
  mission_golden_4: '골드 헌터',
  mission_golden_4_desc: '골든 이벤트 4번 터치',
  mission_earn_10m: '재벌',
  mission_earn_10m_desc: '🛸 10M 획득',

  // Conquest
  cq_title: '세계 정복',
  cq_progress: '정복 현황',
  cq_infiltration_power: '침투력',
  cq_active_conquest: '침투 중',
  cq_infiltration_progress: '침투 진행도',
  cq_time_remaining: '예상 완료 시간',
  cq_start_infiltration: '침투 시작',
  cq_stop_infiltration: '침투 중지',
  cq_no_power_hint: '요원을 고용하면 침투력이 생깁니다',
  cq_locked: '잠김',
  cq_available: '침투 가능',
  cq_conquered: '정복 완료',
  cq_popup_title: '정복 완료!',
  cq_popup_desc: '을(를) 정복했습니다! 시설을 건설하여 더 강해지세요.',
  cq_back: '뒤로',
  cq_invest_title: '🛸를 투자하여 정복',
  cq_current_ip: '보유 🛸',
  cq_facilities: '시설',
  cq_build: '건설',
  cq_upgrade: '강화',
  cq_next_level: '다음',
  cq_counter_intel_title: '방첩 경보!',
  cq_counter_intel_text: '{country}에서 침투가 발각되었습니다! 진행도가 감소합니다.',
  cq_defend_ad: '광고 보고 방어',
  cq_accept_loss: '손실 감수',
  cq_ending_title: '지구 정복 완료!',
  cq_ending_text: '렙틸리언 음모가 완성되었습니다. 모든 국가가 그림자 제국 앞에 무릎을 꿇었습니다.',
  cq_ending_time: '플레이 시간',
  cq_ending_prestiges: '환생 횟수',
  cq_ending_total_ip: '총 🛸',
  cq_ending_taps: '총 탭 수',
  cq_ending_continue: '계속 플레이',
  // Countries
  cq_egypt: '이집트', cq_egypt_desc: '피라미드 고대 기지',
  cq_brazil: '브라질', cq_brazil_desc: '아마존 밀림 은신처',
  cq_india: '인도', cq_india_desc: '나가 신앙 침투',
  cq_australia: '호주', cq_australia_desc: '사막 지하 벙커',
  cq_japan: '일본', cq_japan_desc: '기술 탈취 작전',
  cq_korea: '한국', cq_korea_desc: 'NIS 사이버 방어 돌파',
  cq_uk: '영국', cq_uk_desc: 'MI5/MI6 왕실 침투',
  cq_russia: '러시아', cq_russia_desc: 'FSB 시베리아 작전',
  cq_china: '중국', cq_china_desc: '세계 최강 감시망',
  cq_usa: '미국', cq_usa_desc: 'CIA/NSA 최종 보스',
  // Facilities
  fac_pyramid_vault: '피라미드 금고', fac_pyramid_vault_d: '레벨당 초당 🛸 +5%',
  fac_nile_network: '나일 네트워크', fac_nile_network_d: '레벨당 오프라인 +5%',
  fac_ancient_lab: '고대 연구소', fac_ancient_lab_d: '레벨당 TAP +10%',
  fac_amazon_hideout: '아마존 은신처', fac_amazon_hideout_d: '레벨당 생산자 할인 +2%',
  fac_samba_broadcast: '삼바 방송국', fac_samba_broadcast_d: '레벨당 초당 🛸 +8%',
  fac_jungle_lab: '정글 연구소', fac_jungle_lab_d: '레벨당 골든 이벤트 +5%',
  fac_naga_temple: '나가 사원', fac_naga_temple_d: '레벨당 💎 +5%',
  fac_bollywood_studio: '볼리우드 스튜디오', fac_bollywood_studio_d: '레벨당 오프라인 +8%',
  fac_caste_network: '카스트 네트워크', fac_caste_network_d: '레벨당 초당 🛸 +12%',
  fac_desert_bunker: '사막 벙커', fac_desert_bunker_d: '레벨당 TAP +15%',
  fac_ayers_signal: '에어즈록 신호기', fac_ayers_signal_d: '레벨당 골든 이벤트 +8%',
  fac_outback_base: '아웃백 기지', fac_outback_base_d: '레벨당 초당 🛸 +15%',
  fac_akiba_ai: '아키하바라 AI', fac_akiba_ai_d: '레벨당 초당 🛸 +20%',
  fac_ninja_intel: '닌자 정보부', fac_ninja_intel_d: '레벨당 생산자 할인 +3%',
  fac_tokyo_tower: '도쿄 타워', fac_tokyo_tower_d: '레벨당 💎 +8%',
  fac_gangnam_hq: '강남 본부', fac_gangnam_hq_d: '레벨당 초당 🛸 +25%',
  fac_cyber_command: '사이버 사령부', fac_cyber_command_d: '레벨당 TAP +25%',
  fac_kpop_brainwash: 'K-Pop 세뇌기', fac_kpop_brainwash_d: '레벨당 💎 +10%',
  fac_royal_infiltrate: '왕실 침투', fac_royal_infiltrate_d: '레벨당 초당 🛸 +30%',
  fac_london_tower: '런던 타워', fac_london_tower_d: '레벨당 오프라인 +15%',
  fac_mi6_double: 'MI6 이중첩자', fac_mi6_double_d: '레벨당 골든 이벤트 +12%',
  fac_siberia_base: '시베리아 기지', fac_siberia_base_d: '레벨당 초당 🛸 +40%',
  fac_kgb_remnant: 'KGB 잔당', fac_kgb_remnant_d: '레벨당 생산자 할인 +5%',
  fac_nuke_bunker: '핵 벙커', fac_nuke_bunker_d: '레벨당 TAP +40%',
  fac_great_wall: '만리방화벽', fac_great_wall_d: '레벨당 초당 🛸 +50%',
  fac_shenzhen_factory: '선전 공장', fac_shenzhen_factory_d: '레벨당 생산자 할인 +8%',
  fac_panda_spy: '팬더 스파이링', fac_panda_spy_d: '레벨당 골든 이벤트 +20%',
  fac_area51: '에어리어 51', fac_area51_d: '레벨당 초당 🛸 +80%',
  fac_pentagon: '펜타곤', fac_pentagon_d: '레벨당 TAP +80%',
  fac_wall_street: '월스트리트', fac_wall_street_d: '레벨당 💎 +25%',

  buy: '\uAD6C\uB9E4', max: '\uCD5C\uB300', level: 'Lv.', locked: '\uC7A0\uAE40', unlocked: '\uD574\uAE08',
  upgrade_locked_prev: '\uC774\uc804 \uc5c5\uadf8\ub808\uc774\ub4dc\ub97c \uba3c\uc800 \ubc30\uc6b0\uc138\uc694',
  condition: '\uC870\uAC74', cost: '\uBE44\uC6A9', owned: '\uBCF4\uC720', effect: '\uD6A8\uACFC', reward: '\uBCF4\uC0C1',
  close: '\uB2EB\uAE30', confirm: '\uD655\uC778', cancel: '\uCDE8\uC18C',

  // Conquest achievements
  ach_filter_conquest: '정복',
  ach_q01: '첫 번째 점령', ach_q01_reward: '\uCD08\uB2F9 \uD83D\uDEF8 +10%',
  ach_q02: '세 나라 점령', ach_q02_reward: 'TAP +10%',
  ach_q03: '절반의 세계', ach_q03_reward: '💎 획득 +15%',
  ach_q04: '일곱 깃발', ach_q04_reward: '오프라인 효율 +20%',
  ach_q05: '세계 정복자', ach_q05_reward: '전체 초당 🛸 x3',
  ach_q06: '시설 마스터', ach_q06_reward: '전체 초당 🛸 x2',
  milestone_next: '다음',
  settings_conquest: '정복 현황',

  // Currency info
  currency_ip_name: '침투 포인트 (IP)',
  currency_ip_earn: '탭, 요원 자동생산, 오프라인 수익, 광고 보상으로 획득',
  currency_ip_use: '요원 고용, 업그레이드 구매, 국가 정복에 투자',
  currency_gc_name: '은하 크레딧 (GC)',
  currency_gc_earn: '환생(조직 재편) 시 누적 IP에 비례하여 획득',
  currency_gc_use: '환생 업그레이드 구매 (생산 배율, 오프라인 효율 등)',
  currency_cores_name: '은하 코어',
  currency_cores_earn: '2차 환생(은하 재편) 시 누적 GC에 비례하여 획득',
  currency_cores_use: '2차 환생 업그레이드 구매 (영구 버프, 자동화 등)',
  currency_docs_name: '기밀 문서',
  currency_docs_earn: '일일 미션 완료, 광고 시청, 업적 달성으로 획득',
  currency_docs_use: '미션 탭의 기밀문서 상점에서 강력한 부스트 아이템 구매',
  currency_how_earn: '획득 방법',
  currency_how_use: '사용처',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: '침투 숙련',
  pup_infiltration_mastery_desc: '레벨당 전체 침투력 +50% (최대 +500%)',
  pup_agent_network: '요원 네트워크',
  pup_agent_network_desc: '레벨당 요원 100명마다 침투력 +5%',
  pup_quick_infiltration: '연쇄 침투',
  pup_quick_infiltration_desc: '나라 정복 시 다음 나라 진행도 +10%/Lv',
  pup_critical_chance: '치명타 훈련',
  pup_critical_chance_desc: '탭 치명타 확률 +3%/Lv (기본 10%, 최대 50%)',
  pup_critical_damage: '치명타 강화',
  pup_critical_damage_desc: '치명타 데미지 +1x/Lv (기본 x3)',

  // Special upgrades - conquest
  special_spy_master: '스파이 마스터',
  special_spy_master_desc: '전체 침투력 x2',

  // Ad reward popups
  ad_income_x5: '30분치 수입 받기',
  ad_income_x5_desc: '광고를 시청하면 현재 초당 수익 30분분인\n{amount} 🛸를 즉시 획득합니다!',
  ad_tap_x10: '터치 x10 (10초)',
  ad_tap_x10_desc: '광고를 시청하면 10초 동안\n탭 수익이 10배로 증가합니다!',
  ad_free_docs_desc: '광고를 시청하면\n기밀 문서 📜 1개를 무료로 획득합니다!',
  ad_prestige_desc: '광고를 시청하면\n15초 동안 초당 수익이 10배로 증가합니다!',
  cq_tutorial_title: '🌍 세계 정복 안내',
  cq_tutorial_text: '국가를 정복하면 <b>시설</b>을 건설할 수 있습니다!\n시설을 강화하면 초당 수익, 탭 수익, 오프라인 수익 등\n<b>영구적인 보너스</b>를 얻을 수 있습니다.\n\n요원을 고용하면 침투력이 올라갑니다.',
  rank_promote: '승급',
  rank_promoted: '승급 완료!',

  // Boss events
  boss_resistance_captain: '저항군 대장',
  boss_resistance_captain_desc: '인간 민병대 지휘관, 노련한 전사',
  boss_cia_agent: 'CIA 요원',
  boss_cia_agent_desc: '기밀 정보를 가진 비밀 공작원',
  boss_mib_investigator: 'MIB 수사관',
  boss_mib_investigator_desc: 'Men In Black 현장 요원',
  boss_un_inspector: 'UN 조사관',
  boss_un_inspector_desc: '국제 음모 추적자',
  boss_whistleblower: '내부 고발자',
  boss_whistleblower_desc: '증거를 가진 배신자',
  boss_journalist: '탐사 기자',
  boss_journalist_desc: '카메라를 든 끈질긴 진실 추적자',
  boss_truth_seeker: '진실 탐구자',
  boss_truth_seeker_desc: '초자연 현상 연구원',
  boss_galactic_guardian: '은하 수호자',
  boss_galactic_guardian_desc: '우주 법칙의 집행자',

  boss_alert: '위협 감지!',
  boss_alert_desc: '적이 나타났다! 탭하여 공격하라!',
  boss_hp: 'HP',
  boss_tap_attack: '탭하여 공격!',
  boss_double_damage: '2x 데미지 (30초)',
  boss_eliminated: '처치 완료!',
  boss_eliminated_desc: '{name}이(가) 무력화되었다!',
  boss_reward_ip: '+{amount} IP',
  boss_reward_docs: '+{amount} Docs',
  boss_reward_gc: '+{amount} GC',
  boss_reward_boost: 'CPS x3 ({seconds}초)',
  boss_claim: '보상 받기',
  boss_claim_double: '2배 보상',
  boss_escaped: '도주!',
  boss_escaped_desc: '대상이 도주했다...',
  boss_revive: '재도전 (+20초)',
  boss_phase2: '격노!',
  boss_streak: '연속 처치: {n}',
  boss_time_remaining: '시간',
  boss_double_damage_active: '2x 데미지 활성화!',

  // Agent collection
  tab_agent: '요원',
  agent_collection_title: '요원 컬렉션',
  agent_equipped: '장착됨',
  agent_empty_slot: '비어있음',
  agent_obtained: '요원 획득!',
  agent_equip: '장착',
  agent_unequip: '해제',
  agent_locked: '???',
  agent_count: 'x{n}',
  agent_tutorial_title: '요원 수집 가이드',
  agent_tutorial_text: '<b>보스</b>를 물리쳐 요원 카드를 수집하세요!<br><br>각 요원은 고유한 패시브 보너스를 가지고 있습니다.<br>카드를 탭하여 요원을 장착하세요.<br><br>높은 희귀도 = 강한 효과.<br>환생하면 장착 슬롯이 늘어납니다.',

  // Agent effect descriptions
  agent_effect_cps_pct: 'CPS {n}',
  agent_effect_tap_pct: 'TAP {n}',
  agent_effect_conquest_speed: '정복 속도 {n}',
  agent_effect_boss_damage: '보스 피해 {n}',
  agent_effect_golden_chance: '황금 이벤트 {n}',
  agent_effect_offline_pct: '오프라인 수입 {n}',
  agent_effect_docs_rate: '문서 비율 {n}',
  agent_effect_gc_pct: 'GC 획득 {n}',
  agent_effect_boss_spawn_reduce: '보스 출현 -{n}',
  agent_effect_prestige_gc_bonus: '프레스티지 GC {n}',
  agent_effect_faction_favor: '세력 호감도 {n}',

  // Agent names & descriptions (25 agents)
  // Common (10)
  agent_field_spy: '현장 스파이',
  agent_field_spy_desc: '현장 정보로 IP 생산 +8% 증가',
  agent_code_cracker: '코드 해독가',
  agent_code_cracker_desc: '해독 기술로 탭 파워 +10% 증가',
  agent_shadow_runner: '섀도우 러너',
  agent_shadow_runner_desc: '은밀 전문 기술로 정복 속도 +10% 증가',
  agent_data_miner: '데이터 채굴자',
  agent_data_miner_desc: '데이터 수집으로 오프라인 수입 +15% 증가',
  agent_lookout: '감시자',
  agent_lookout_desc: '예리한 눈으로 황금 이벤트 확률 +10% 증가',
  agent_doc_thief: '문서 도둑',
  agent_doc_thief_desc: '문서 탈취로 문서 획득량 +15% 증가',
  agent_network_bot: '네트워크 봇',
  agent_network_bot_desc: '자동화 네트워크로 CPS +10% 증가',
  agent_safe_cracker: '금고 해제자',
  agent_safe_cracker_desc: '금고 기술로 탭 파워 +12% 증가',
  agent_recruit: '신입 요원',
  agent_recruit_desc: '신참 전사로 보스 피해 +10% 증가',
  agent_comm_officer: '통신 장교',
  agent_comm_officer_desc: '통신 기술로 세력 호감도 +10% 증가',

  // Rare (8)
  agent_infiltration_ace: '잠입 에이스',
  agent_infiltration_ace_desc: '엘리트 잠입으로 CPS +20% 증가',
  agent_mind_bender: '마인드 벤더',
  agent_mind_bender_desc: '정신 능력으로 정복 속도 +25% 증가',
  agent_vault_raider: '금고 습격자',
  agent_vault_raider_desc: '금고 전문으로 GC 획득 +20% 증가',
  agent_signal_jammer: '신호 교란자',
  agent_signal_jammer_desc: '교란으로 보스 출현 간격 -15% 감소',
  agent_double_agent: '이중 스파이',
  agent_double_agent_desc: '이중 충성으로 오프라인 수입 +30% 증가',
  agent_hive_mind: '하이브 마인드',
  agent_hive_mind_desc: '집단 의식으로 문서 비율 +25% 증가',
  agent_boss_hunter: '보스 헌터',
  agent_boss_hunter_desc: '전문 추적으로 보스 피해 +25% 증가',
  agent_faction_liaison: '세력 연락관',
  agent_faction_liaison_desc: '외교 관계로 세력 호감도 +25% 증가',

  // Epic (5)
  agent_reptilian_elite: '렙틸리안 엘리트',
  agent_reptilian_elite_desc: '엘리트 전사로 CPS +35% 증가',
  agent_galaxy_commander: '은하 사령관',
  agent_galaxy_commander_desc: '은하 권위로 GC 획득 +40% 증가',
  agent_dark_secretary: '암흑 비서관',
  agent_dark_secretary_desc: '그림자 관료로 프레스티지 GC +20% 증가',
  agent_omega_operative: '오메가 공작원',
  agent_omega_operative_desc: '궁극의 전사로 보스 피해 +50% 증가',
  agent_shapeshifter: '변신술사',
  agent_shapeshifter_desc: '변신 달인으로 탭 파워 +40% 증가',

  // Legendary (2)
  agent_the_overlord: '대군주',
  agent_the_overlord_desc: '최고 사령관으로 전체 CPS +50% 증가',
  agent_grand_architect: '대건축가',
  agent_grand_architect_desc: '우주 설계자로 정복 속도 +60% 증가',
  // Faction system
  faction_status_title: '세력 현황',
  faction_favorability: '호감도',
  faction_tier: '등급 {n}',

  // Faction event popup
  faction_event_help: '도움',
  faction_event_ignore: '무시',
  faction_event_timer: '{seconds}초 남음',
  faction_event_reward: '+{favor} {faction} 호감도, -{loss} {target} 호감도',
  faction_event_ip_reward: '+{amount} IP 보상',
  faction_event_ad_bonus: '광고 보기: +{n} {faction} 호감도',

  // Faction names
  faction_illuminati: '일루미나티',
  faction_illuminati_desc: '그림자 속에서 세상을 조종하는 비밀 인간 지배자',
  faction_grey: '그레이 외계인',
  faction_grey_desc: '기술을 공유하는 외계 종족',
  faction_mib: 'MIB 레지스탕스',
  faction_mib_desc: '외계인의 영향력에 맞서 싸우는 비밀 인간 조직',

  // Faction bonus descriptions
  faction_illuminati_bonus1: 'CPS +10%',
  faction_illuminati_bonus2: 'CPS +15%',
  faction_illuminati_bonus3: '정복 속도 +20%',
  faction_grey_bonus1: '탭 +15%',
  faction_grey_bonus2: '탭 +20%',
  faction_grey_bonus3: '골든 쿠키 +25%',
  faction_mib_bonus1: '보스 피해 +20%',
  faction_mib_bonus2: '오프라인 수입 +15%',
  faction_mib_bonus3: '보스 출현 -15%',

  // Event titles and descriptions
  event_illu_decode_title: '기밀 감청',
  event_illu_decode_desc: '일루미나티가 정부 기밀 파일을 가로채고 있습니다. 해독을 도와줄까요?',
  event_illu_stock_title: '시장 조작',
  event_illu_stock_desc: '일루미나티가 글로벌 주식 시장을 조작하려 합니다. 내부 정보를 제공할까요?',
  event_illu_surveillance_title: '감시 네트워크',
  event_illu_surveillance_desc: '일루미나티가 비밀 감시 네트워크를 구축하고 있습니다. 건설을 도울까요?',
  event_illu_meeting_title: '비밀 정상회담',
  event_illu_meeting_desc: '세계 지도자 모임에서 일루미나티 비밀 회의가 열립니다. 경호를 맡을까요?',
  event_illu_bribe_title: '외계인 외교',
  event_illu_bribe_desc: '일루미나티가 외계인 외교관에게 뇌물을 전달하려 합니다. 전달할까요?',

  event_grey_experiment_title: '인체 실험',
  event_grey_experiment_desc: '그레이 외계인이 인간을 대상으로 실험하고 있습니다. 연구소를 경비할까요?',
  event_grey_mindcontrol_title: '마인드 컨트롤 장치',
  event_grey_mindcontrol_desc: '그레이 외계인이 도시에 마인드 컨트롤 장치를 설치하려 합니다. 건설을 도울까요?',
  event_grey_crash_title: '추락 복구',
  event_grey_crash_desc: '그레이 정찰선이 사막에 추락했습니다. 승무원 구출을 도울까요?',
  event_grey_terraform_title: '비밀 테라포밍',
  event_grey_terraform_desc: '그레이 외계인이 비밀리에 섬을 테라포밍하고 있습니다. 자원을 제공할까요?',
  event_grey_hack_title: '위성 해킹',
  event_grey_hack_desc: '그레이 외계인이 지구 위성 네트워크를 해킹하려 합니다. 접근 코드를 제공할까요?',

  event_mib_raid_title: '외계인 전초기지 급습',
  event_mib_raid_desc: 'MIB가 외계인 전초기지 급습을 계획하고 있습니다. 공격에 참여할까요?',
  event_mib_safehouse_title: '은신처 발견',
  event_mib_safehouse_desc: 'MIB가 숨겨진 일루미나티 은신처를 발견했습니다. 급습을 도울까요?',
  event_mib_weapons_title: '무기 개발',
  event_mib_weapons_desc: 'MIB가 대외계인 무기를 개발하고 있습니다. 희귀 재료를 제공할까요?',
  event_mib_evacuate_title: '민간인 대피',
  event_mib_evacuate_desc: 'MIB가 외계인 공격 구역에서 민간인을 대피시켜야 합니다. 도울까요?',
  event_mib_expose_title: '부패 폭로',
  event_mib_expose_desc: 'MIB가 일루미나티의 부패를 대중에게 폭로하려 합니다. 문서를 유출할까요?',

  // Shadow Contact (mid-game ad choices)
  sc_title: '그림자 접선',
  sc_accept: '거래 수락',
  sc_decline: '거절',
  sc_offer_intel: '정보 보고서',
  sc_offer_intel_desc: '이중 스파이가 {amount} 🛸 상당의 기밀 정보를 제공합니다',
  sc_offer_serum: '실험용 혈청',
  sc_offer_serum_desc: '탭 파워를 30초간 10배로 증폭시키는 외계 실험체 샘플',
  sc_offer_tech: '암시장 기술',
  sc_offer_tech_desc: '30초간 수입을 10배로 늘려주는 탈취된 외계 기술',
  sc_offer_docs: '기밀 문서 더미',
  sc_offer_docs_desc: '기밀 문서 3개가 숨겨진 비밀 은닉처 📜',
  boss_warning: '경고',
  boss_warning_sub: '강력한 적이 다가오고 있습니다...',
  boss_tutorial_title: '보스전!',
  boss_tutorial_text: '보스가 나타났습니다! 빠르게 탭하여 시간 내에 데미지를 입히세요.<br><br>보스를 처치하면 <b>IP, 문서, 요원 카드</b>를 획득합니다!<br>광고 시청으로 <b>2배 데미지</b> 부스트.',
  // === Infiltration Run (generated) ===
  tab_infiltration: "잠입",
  infil_eyebrow: "잠입 작전",
  infil_title: "잠입 침투",
  infil_subtitle: "몰래 침투해 직위를 얻고 무사히 빠져나가라.",
  infil_tutorial_note: "첫 작전: 요령을 익히세요. 최상위 직위를 무리하게 노리면 발각됩니다.",
  infil_agent_stats: "요원 스탯",
  infil_highest_career: "최고 직위",
  infil_total_runs: "총 작전",
  infil_total_success: "성공",
  infil_tradeoff_hint: "안전=적은 보상·낮은 직위. 욕심=발각 급증·큰 위험. 매 선택을 저울질하라.",
  infil_start: "잠입 시작",
  infil_start_tutorial: "튜토리얼 시작",
  infil_cooldown: "재정비",
  infil_cancel: "취소",
  infil_detection: "발각도",
  infil_step: "사건",
  infil_difficulty: "난이도",
  infil_selecting: "선택 중",
  infil_choice_success: "성공",
  infil_choice_fail: "실패",
  infil_roll: "판정",
  infil_next: "다음",
  infil_to_extraction: "탈출 단계로",
  infil_extraction_cat: "최종 단계",
  infil_extraction_title: "탈출",
  infil_extraction_desc: "모든 사건 통과. 이제 탈출하라. 발각도가 낮을수록 안전하다.",
  infil_attempt_extraction: "탈출 시도",
  infil_final_chance: "탈출 성공률",
  infil_result_success: "잠입 성공",
  infil_result_fail: "발각됨",
  infil_result_success_sub: "무사히 빠져나와 위장 직위를 확보했다.",
  infil_result_fail_sub: "보안에 발각됐다. 이번엔 소득이 없다.",
  infil_docs: "문서",
  infil_cleared: "통과",
  infil_career_earned: "확보한 직위",
  infil_fail_note: "보상 없음. 다음 작전까지 잠시 대기.",
  infil_retry_ad: "광고 보고 재시도",
  infil_retry_title: "재시도",
  infil_retry_desc: "짧은 광고를 보고 발각도를 낮춰 탈출을 한 번 더 시도합니다.",
  infil_retry_confirm: "광고 보기",
  infil_close: "닫기",
  infil_stat_disguise: "위장",
  infil_stat_combat: "전투",
  infil_stat_hacking: "해킹",
  infil_stat_charisma: "화술",
  infil_stat_none: "판정 없음",
  infil_tag_safe: "안전",
  infil_tag_risky: "위험",
  infil_tag_aggressive: "강행",
  infil_career_cleaner: "청소부",
  infil_career_guard: "경비",
  infil_career_clerk: "사무원",
  infil_career_manager: "관리자",
  infil_career_executive: "임원",
  infil_career_director: "이사",
  infil_career_warrior: "전사",
  infil_career_none: "없음",
  infil_ev_patrol_cat: "침투 사건 / 기업국가",
  infil_ev_patrol_title: "순찰대 접근",
  infil_ev_patrol_desc: "보안 순찰대가 당신 쪽으로 곧장 다가온다. 어떻게 대응할까?",
  infil_ch_patrol_a_label: "그늘에 숨어 대기",
  infil_ch_patrol_a_desc: "지나갈 때까지 숨죽여 기다린다. 안전하지만 시간이 지연된다.",
  infil_ch_patrol_b_label: "직원인 척 인사",
  infil_ch_patrol_b_desc: "위장 신분으로 자연스럽게 인사하며 지나친다.",
  infil_ch_patrol_c_label: "제압 후 돌파",
  infil_ch_patrol_c_desc: "순찰대를 기습 제압하고 강행 돌파한다. 큰 보상, 큰 위험.",
  infil_ev_security_check_cat: "침투 사건 / 기업국가",
  infil_ev_security_check_title: "보안 검색대",
  infil_ev_security_check_desc: "유인 검색대가 앞쪽 복도를 막고 있다.",
  infil_ch_security_check_a_label: "검색대 우회로 탐색",
  infil_ch_security_check_a_desc: "옆 통로로 조용히 우회한다.",
  infil_ch_security_check_b_label: "위조 출입증 제시",
  infil_ch_security_check_b_desc: "정교한 위조 출입증으로 통과를 시도한다.",
  infil_ch_security_check_c_label: "검색대 시스템 해킹",
  infil_ch_security_check_c_desc: "검색 단말을 해킹해 경보를 무력화한다.",
  infil_ev_informant_cat: "침투 사건 / 기업국가",
  infil_ev_informant_title: "내부 정보원 포섭",
  infil_ev_informant_desc: "내부자가 대가만 맞으면 기밀을 넘길지 모른다.",
  infil_ch_informant_a_label: "익명 제보만 받기",
  infil_ch_informant_a_desc: "접촉 없이 익명 제보함만 확인한다.",
  infil_ch_informant_b_label: "정보원 설득",
  infil_ch_informant_b_desc: "화술로 내부 직원을 포섭한다.",
  infil_ch_informant_c_label: "협박으로 정보 갈취",
  infil_ch_informant_c_desc: "정보원을 협박해 강제로 자료를 빼낸다.",
  infil_ev_cctv_cat: "침투 사건 / 기업국가",
  infil_ev_cctv_title: "CCTV 우회",
  infil_ev_cctv_desc: "천장 가득한 카메라가 홀 전체를 훑는다.",
  infil_ch_cctv_a_label: "사각지대로 이동",
  infil_ch_cctv_a_desc: "카메라 사각을 따라 천천히 이동한다.",
  infil_ch_cctv_b_label: "CCTV 루프 삽입",
  infil_ch_cctv_b_desc: "감시 영상에 가짜 루프를 심는다.",
  infil_ch_cctv_c_label: "카메라 물리 파괴",
  infil_ch_cctv_c_desc: "카메라를 부수고 빠르게 통과한다.",
  infil_ev_fake_id_cat: "침투 사건 / 기업국가",
  infil_ev_fake_id_title: "위조 신분증 검문",
  infil_ev_fake_id_desc: "경비가 긴 줄에서 신분증을 일일이 검사한다.",
  infil_ch_fake_id_a_label: "검문 줄에서 이탈",
  infil_ch_fake_id_a_desc: "조용히 줄에서 빠져 다른 길을 찾는다.",
  infil_ch_fake_id_b_label: "위조 신분증 제시",
  infil_ch_fake_id_b_desc: "정교한 위조 신분증으로 검문을 통과한다.",
  infil_ch_fake_id_c_label: "검문관 구슬리기",
  infil_ch_fake_id_c_desc: "능란한 말솜씨로 검문관을 넘어간다.",
  infil_ev_parking_cat: "침투 사건 / 기업국가",
  infil_ev_parking_title: "지하 주차장",
  infil_ev_parking_desc: "주차장이 진입로지만 경비가 순찰 중이다.",
  infil_ch_parking_a_label: "차량 뒤에 은신",
  infil_ch_parking_a_desc: "주차된 차량 사이에 몸을 숨긴다.",
  infil_ch_parking_b_label: "경비 무력화",
  infil_ch_parking_b_desc: "주차장 경비를 조용히 제압한다.",
  infil_ch_parking_c_label: "발렛 직원 위장",
  infil_ch_parking_c_desc: "발렛 유니폼을 훔쳐 입고 활보한다.",
  infil_ev_server_room_cat: "침투 사건 / 기업국가",
  infil_ev_server_room_title: "서버실 침투",
  infil_ev_server_room_desc: "핵심 데이터가 강화된 서버실 문 뒤에 있다.",
  infil_ch_server_room_a_label: "환기구로 우회",
  infil_ch_server_room_a_desc: "좁은 환기구를 통해 우회한다. 느리지만 안전.",
  infil_ch_server_room_b_label: "서버 접근권 탈취",
  infil_ch_server_room_b_desc: "관리자 권한을 탈취해 서버실을 연다.",
  infil_ch_server_room_c_label: "보안문 강제 개방",
  infil_ch_server_room_c_desc: "보안문을 뜯어내고 강행 진입한다.",
  infil_ev_board_meeting_cat: "침투 사건 / 기업국가",
  infil_ev_board_meeting_title: "임원 회의 잠입",
  infil_ev_board_meeting_desc: "최고 임원들이 닫힌 문 뒤에서 기밀을 나눈다.",
  infil_ch_board_meeting_a_label: "복도에서 도청",
  infil_ch_board_meeting_a_desc: "회의실 밖에서 조용히 도청만 한다.",
  infil_ch_board_meeting_b_label: "컨설턴트로 위장 발언",
  infil_ch_board_meeting_b_desc: "외부 컨설턴트인 척 회의에 끼어든다.",
  infil_ch_board_meeting_c_label: "회의장 급습",
  infil_ch_board_meeting_c_desc: "회의장을 급습해 기밀을 통째로 탈취한다. 전사 노림수.",
  infil_ev_reporter_cat: "침투 사건 / 기업국가",
  infil_ev_reporter_title: "기자 미행 따돌리기",
  infil_ev_reporter_desc: "집요한 기자가 당신의 모든 동선을 미행한다.",
  infil_ch_reporter_a_label: "인파 속으로 섞이기",
  infil_ch_reporter_a_desc: "붐비는 거리로 들어가 미행을 흘린다.",
  infil_ch_reporter_b_label: "변장 후 방향 전환",
  infil_ch_reporter_b_desc: "겉옷을 바꿔 입고 경로를 튼다.",
  infil_ch_reporter_c_label: "역으로 접근해 회유",
  infil_ch_reporter_c_desc: "기자에게 먼저 접근해 거짓 정보를 흘린다.",
  infil_ev_party_cat: "침투 사건 / 기업국가",
  infil_ev_party_title: "파티 잠입",
  infil_ev_party_desc: "화려한 파티가 접근해야 할 인물들을 감추고 있다.",
  infil_ch_party_a_label: "웨이터 트레이 들기",
  infil_ch_party_a_desc: "빈 트레이를 들고 서빙하는 척 이동한다.",
  infil_ch_party_b_label: "초대 손님 행세",
  infil_ch_party_b_desc: "능청스럽게 초대 손님인 척 어울린다.",
  infil_ch_party_c_label: "VIP로 위장 입장",
  infil_ch_party_c_desc: "VIP 분장을 하고 정문으로 당당히 들어간다.",
  infil_ev_drone_cat: "침투 사건 / 기업국가",
  infil_ev_drone_title: "드론 감시",
  infil_ev_drone_desc: "감시 드론이 트인 마당을 훑고 지나간다.",
  infil_ch_drone_a_label: "구조물 아래 대기",
  infil_ch_drone_a_desc: "드론이 지나갈 때까지 구조물 밑에 숨는다.",
  infil_ch_drone_b_label: "드론 신호 재밍",
  infil_ch_drone_b_desc: "드론 통신을 재밍해 눈을 가린다.",
  infil_ch_drone_c_label: "드론 격추",
  infil_ch_drone_c_desc: "드론을 격추한다. 확실하지만 흔적이 남는다.",
  infil_ev_guard_shift_cat: "침투 사건 / 기업국가",
  infil_ev_guard_shift_title: "경비 교대 타이밍",
  infil_ev_guard_shift_desc: "경비 교대가 잠깐의 감시 공백을 만든다.",
  infil_ch_guard_shift_a_label: "교대 시간까지 대기",
  infil_ch_guard_shift_a_desc: "다음 교대까지 기다렸다 빈틈에 이동한다.",
  infil_ch_guard_shift_b_label: "교대 경비로 위장",
  infil_ch_guard_shift_b_desc: "교대 인원인 척 초소에 들어선다.",
  infil_ch_guard_shift_c_label: "경비 기습 제압",
  infil_ch_guard_shift_c_desc: "교대 직전 경비를 기습 제압한다.",
  infil_ev_vault_cat: "침투 사건 / 기업국가",
  infil_ev_vault_title: "비밀 금고",
  infil_ev_vault_desc: "숨겨진 금고에 최고 기밀 문서가 들어 있다.",
  infil_ch_vault_a_label: "금고 포기하고 우회",
  infil_ch_vault_a_desc: "금고를 건드리지 않고 목표만 챙긴다.",
  infil_ch_vault_b_label: "금고 전자락 해제",
  infil_ch_vault_b_desc: "전자 잠금장치를 해킹해 금고를 연다.",
  infil_ch_vault_c_label: "금고 강제 폭파",
  infil_ch_vault_c_desc: "금고를 폭파해 내용물을 탈취한다. 최고 보상.",
  infil_ev_vaccine_cat: "침투 사건 / 기업국가",
  infil_ev_vaccine_title: "백신 접종소 위장",
  infil_ev_vaccine_desc: "임시 접종소는 내부로 들어갈 완벽한 위장이다.",
  infil_ch_vaccine_a_label: "접종 대기열에 서기",
  infil_ch_vaccine_a_desc: "일반 접종자인 척 줄에 선다.",
  infil_ch_vaccine_b_label: "의료진 가운 착용",
  infil_ch_vaccine_b_desc: "의료진 가운을 입고 내부로 들어간다.",
  infil_ch_vaccine_c_label: "관리자 사칭 지시",
  infil_ch_vaccine_c_desc: "책임자를 사칭해 직원들을 물린다.",
  infil_ev_broadcast_cat: "침투 사건 / 기업국가",
  infil_ev_broadcast_title: "방송국 송출실",
  infil_ev_broadcast_desc: "방송 송출은 당신의 메시지나 증거를 실어 나를 수 있다.",
  infil_ch_broadcast_a_label: "송출 로그만 열람",
  infil_ch_broadcast_a_desc: "송출 기록만 몰래 확인한다.",
  infil_ch_broadcast_b_label: "송출 신호 가로채기",
  infil_ch_broadcast_b_desc: "송출 신호를 해킹해 데이터를 빼낸다.",
  infil_ch_broadcast_c_label: "PD 사칭 생방 진입",
  infil_ch_broadcast_c_desc: "생방송 PD를 사칭해 송출실을 장악한다.",
  infil_ev_border_cat: "침투 사건 / 기업국가",
  infil_ev_border_title: "국경 검문소",
  infil_ev_border_desc: "삼엄한 국경이 당신과 목표 사이를 가로막는다.",
  infil_ch_border_a_label: "검문 없는 샛길",
  infil_ch_border_a_desc: "감시가 없는 샛길로 국경을 넘는다.",
  infil_ch_border_b_label: "여권 검문관 설득",
  infil_ch_border_b_desc: "화술로 검문관의 의심을 푼다.",
  infil_ch_border_c_label: "외교관 위장 통과",
  infil_ch_border_c_desc: "외교 신분으로 위장해 통과한다.",
  infil_ch_border_d_label: "차단봉 돌파",
  infil_ch_border_d_desc: "차량으로 차단봉을 부수고 질주한다.",
} as const;
